// Re-export calculateProduction so existing imports from gameData continue to work
export { calculateProduction } from './pokemonMaths';

// --- CONSTANTS ---

export const ALL_SUBSKILLS = [
  "Berry Finding S", "Dream Shard Bonus", "Energy Recovery Bonus", "Helping Bonus",
  "Helping Speed S", "Helping Speed M", "Ingredient Finder S", "Ingredient Finder M",
  "Inventory Up S", "Inventory Up M", "Inventory Up L", "Research EXP Bonus",
  "Skill Level Up S", "Skill Level Up M", "Skill Trigger S", "Skill Trigger M", "Sleep EXP Bonus"
];

export const NATURES = {
  "Hardy": { up: null, down: null }, "Lonely": { up: "Speed", down: "Energy" },
  "Brave": { up: "Speed", down: "Exp" }, "Adamant": { up: "Speed", down: "Ing" },
  "Naughty": { up: "Speed", down: "Skill" }, "Bold": { up: "Energy", down: "Speed" },
  "Docile": { up: null, down: null }, "Relaxed": { up: "Energy", down: "Exp" },
  "Impish": { up: "Energy", down: "Ing" }, "Lax": { up: "Energy", down: "Skill" },
  "Timid": { up: "Exp", down: "Speed" }, "Hasty": { up: "Exp", down: "Energy" },
  "Serious": { up: null, down: null }, "Jolly": { up: "Exp", down: "Ing" },
  "Naive": { up: "Exp", down: "Skill" }, "Modest": { up: "Ing", down: "Speed" },
  "Mild": { up: "Ing", down: "Energy" }, "Quiet": { up: "Ing", down: "Exp" },
  "Bashful": { up: null, down: null }, "Rash": { up: "Ing", down: "Skill" },
  "Calm": { up: "Skill", down: "Speed" }, "Gentle": { up: "Skill", down: "Energy" },
  "Sassy": { up: "Skill", down: "Exp" }, "Careful": { up: "Skill", down: "Ing" },
  "Quirky": { up: null, down: null },
};

export const BERRY_ICONS = {
  "PERSIM": "/images/berries/persim.png", 
  "LEPPA": "/images/berries/leppa.png",
  "ORAN": "/images/berries/oran.png", 
  "GREPA": "/images/berries/grepa.png",
  "DURIN": "/images/berries/durin.png", 
  "RAWST": "/images/berries/rawst.png",
  "CHERI": "/images/berries/cheri.png", 
  "CHESTO": "/images/berries/chesto.png",
  "FIGY": "/images/berries/figy.png", 
  "PAMTRE": "/images/berries/pamtre.png",
  "MAGO": "/images/berries/mago.png", 
  "LUM": "/images/berries/lum.png",
  "SITRUS": "/images/berries/sitrus.png", 
  "BLUK": "/images/berries/bluk.png",
  "YACHE": "/images/berries/yache.png", 
  "BELUE": "/images/berries/belue.png",
  "WIKI": "/images/berries/wiki.png", 
  "PECHA": "/images/berries/pecha.png"
};

export const INGREDIENT_ICONS = {
  "FANCY_APPLE": "/images/ingredient/apple.png",
  "MOOMOO_MILK": "/images/ingredient/milk.png",
  "GREENGRASS_SOYBEANS": "/images/ingredient/soybean.png",
  "HONEY": "/images/ingredient/honey.png",
  "BEAN_SAUSAGE": "/images/ingredient/sausage.png",
  "WARMING_GINGER": "/images/ingredient/ginger.png",
  "SNOOZY_TOMATO": "/images/ingredient/tomato.png",
  "SOFT_POTATO": "/images/ingredient/potato.png",
  "FIERY_HERB": "/images/ingredient/herb.png",
  "PURE_OIL": "/images/ingredient/oil.png",
  "GREENGRASS_CORN": "/images/ingredient/corn.png",
  "SOOTHING_CACAO": "/images/ingredient/cacao.png",
  "TASTY_MUSHROOM": "/images/ingredient/mushroom.png",
  "LARGE_LEEK": "/images/ingredient/leek.png", 
  "SLOWPOKE_TAIL": "/images/ingredient/tail.png",
  "FANCY_EGG": "/images/ingredient/egg.png",
  "ROUSING_COFFEE": "/images/ingredient/coffee.png",
  "GLOSSY_AVOCADO": "/images/ingredient/avocado.png",
  "PLUMP_PUMPKIN": "/images/ingredient/pumpkin.png"
};

export const MAIN_SKILL_ICONS = {
  "ChargeStrengthS": "/images/mainskill/strength.png",
  "ChargeStrengthM": "/images/mainskill/strength.png",
  "ChargeStrengthSRange": "/images/mainskill/strength.png",
  "ChargeEnergyS": "/images/mainskill/energy.png",
  "EnergyForEveryone": "/images/mainskill/energy.png",
  "IngredientMagnetS": "/images/mainskill/ingredients.png",
  "DreamShardMagnetS": "/images/mainskill/shards.png",
  "DreamShardMagnetSRange": "/images/mainskill/shards.png",
  "EnergizingCheerS": "/images/mainskill/energy.png",
  "Metronome": "/images/mainskill/metronome.png",
  "ExtraHelpfulS": "/images/mainskill/helps.png",
  "HelperBoost": "/images/mainskill/helps.png",
  "CookingPowerUpS": "/images/mainskill/pot.png",
  "TastyChanceS": "/images/mainskill/pot.png",
  "BerryBurst": "/images/mainskill/strength.png",
  "SkillCopyMimic": "/images/mainskill/copy.png",
  "SkillCopyTransform": "/images/mainskill/copy.png",
  "IngredientDrawS": "/images/mainskill/ingredient_draw.png",
  "BerryBurstDisguise": "/images/mainskill/strength.png",
  "ChargeEnergySMoonlight": "/images/mainskill/energy.png",
  "ChargeStrengthSStockpile": "/images/mainskill/stockpile_strength.png",
  "CookingPowerUpSMinus": "/images/mainskill/pot.png",
  "CookingAssistS": "/images/mainskill/pot.png", 
  "BulkUp": "/images/mainskill/pot.png",
  "EnergizingCheerSNuzzle": "/images/mainskill/energy.png",
  "EnergyForEveryoneBerryJuice": "/images/mainskill/energy.png",
  "EnergyForEveryoneLunarBlessing": "/images/mainskill/energy.png",
  "IngredientDrawSHyperCutter": "/images/mainskill/ingredient_draw.png",
  "IngredientDrawSSuperLuck": "/images/mainskill/ingredient_draw.png",
  "IngredientMagnetSPlus": "/images/mainskill/ingredients.png",
  "PresentIngredientMagnetS": "/images/mainskill/ingredients.png",
  "Stockpile": "/images/mainskill/strength.png",
  "Bad Dreams": "/images/mainskill/strength.png",
  "SuperLuck": "/images/mainskill/ingredient_draw.png",
  "HyperCutter": "/images/mainskill/ingredient_draw.png",
  "Plus": "/images/mainskill/ingredients.png",
  "HealPulse": "/images/mainskill/energy.png",
  "Nuzzle": "/images/mainskill/chance.png",
  "BerryJuice": "/images/mainskill/energy.png",
  "LunarBlessing": "/images/mainskill/energy.png",
  "Transform": "/images/mainskill/copy.png",
  "Mimic": "/images/mainskill/copy.png",
  "Versatile": "/images/mainskill/metronome.png"
};

export const SUBSKILL_ABBREVIATIONS = {
  "Berry Finding S": "BFS",
  "Helping Bonus": "HB",
  "Helping Speed S": "HSS",
  "Helping Speed M": "HSM",
  "Ingredient Finder S": "IFS",
  "Ingredient Finder M": "IFM",
  "Skill Trigger S": "STS",
  "Skill Trigger M": "STM",
  "Skill Level Up S": "SLS",
  "Skill Level Up M": "SLM",
  "Inventory Up S": "InvS",
  "Inventory Up M": "InvM",
  "Inventory Up L": "InvL",
  "Energy Recovery Bonus": "ERB",
  "Dream Shard Bonus": "DSB",
  "Sleep EXP Bonus": "SEB",
  "Research EXP Bonus": "REB"
};

export const HYBRID_ROLES = {
  "slaking": { role: "Skill", label: "Skill Trigger", icon: "⚡", desc: "High skill trigger rate makes it play like a Skill Specialist." },
  "sceptile": { role: "Ingredient", label: "High Yield", icon: "🍎", desc: "High ingredient rate and speed makes it a potent farmer." },
  "vaporeon": { role: "Ingredient", label: "Ing. Magnet", icon: "🧲", desc: "Triggers Ingredient Magnet frequently." },
  "butterfree": { role: "Skill", label: "Ing. Magnet", icon: "🧲", desc: "Frequent skill triggers provide consistent ingredients." },
  "tyranitar": { role: "Berry", label: "Raw Power", icon: "💪", desc: "Massive stats make it a top Berry producer." },
  "gengar": { role: "Berry", label: "Speedster", icon: "🚀", desc: "Extreme speed allows it to function as a Berry specialist." },
  "slowbro": { role: "Ingredient", label: "Tail Farmer", icon: "🥩", desc: "Primarily used to unlock Slowpoke Tails." },
  "slowking": { role: "Ingredient", label: "Tail Farmer", icon: "🥩", desc: "Primarily used to unlock Slowpoke Tails." }
};

export const TYPE_ICONS = {
  "Normal": "⚪", "Fire": "🔥", "Water": "💧", "Electric": "⚡", "Grass": "🍃",
  "Ice": "❄️", "Fighting": "👊", "Poison": "☠️", "Ground": "🏜️", "Flying": "🪽",
  "Psychic": "🔮", "Bug": "🐛", "Rock": "🪨", "Ghost": "👻", "Dragon": "🐉",
  "Steel": "🔩", "Dark": "🌑", "Fairy": "✨"
};

export const TYPE_TO_BERRY = {
  "Normal": "Persim", "Fire": "Leppa", "Water": "Oran", "Electric": "Grepa",
  "Grass": "Durin", "Ice": "Rawst", "Fighting": "Cheri", "Poison": "Chesto",
  "Ground": "Figy", "Flying": "Pamtre", "Psychic": "Mago", "Bug": "Lum",
  "Rock": "Sitrus", "Ghost": "Bluk", "Dragon": "Yache", "Steel": "Belue",
  "Dark": "Wiki", "Fairy": "Pecha"
};

export const BERRY_TO_TYPE = Object.fromEntries(
  Object.entries(TYPE_TO_BERRY).map(([type, berry]) => [berry.toUpperCase(), type])
);

// --- HELPER FUNCTIONS ---

export const getSkillColor = (name) => {
  if (!name) return "bg-gray-100 text-gray-400 border-gray-200";
  
  if (name.includes("Bonus") || name.includes("Finding") || name === "Skill Level Up M") {
    return "bg-yellow-100 text-yellow-800 border-yellow-300";
  }
  
  if (name.includes("M") || name.includes("L")) {
    return "bg-blue-100 text-blue-800 border-blue-300";
  }
  
  return "bg-white text-gray-600 border-gray-200";
};

export const calculateTimeFull = (freqStr, carrySize) => {
  if (!freqStr || !carrySize) return null;
  let seconds = 0;
  if (typeof freqStr === 'string' && freqStr.includes(',')) {
     const parts = freqStr.split(',').map(Number);
     seconds = (parts[0] * 3600) + (parts[1] * 60) + parts[2];
  } else {
     seconds = parseInt(freqStr);
  }
  if (!seconds) return null;
  const totalSeconds = seconds * carrySize;
  return (totalSeconds / 3600).toFixed(1);
};

export const formatSkillName = (name) => {
    if (!name) return "Unknown";
    const customNames = {
        "ChargeStrengthSRange": "Charge Strength S (Range)",
        "ChargeStrengthSStockpile": "Charge Strength S (Stockpile)",
        "Stockpile": "Charge Strength S (Stockpile)",
        "EnergyForEveryone": "Energy for Everyone",
        "EnergyForEveryoneBerryJuice": "Energy for Everyone (Berry Juice)",
        "BerryJuice": "Energy for Everyone (Berry Juice)",
        "EnergyForEveryoneLunarBlessing": "Energy for Everyone (Lunar Blessing)",
        "LunarBlessing": "Energy for Everyone (Lunar Blessing)",
        "IngredientMagnetS": "Ingredient Magnet S",
        "IngredientMagnetSPlus": "Ingredient Magnet S (Plus)",
        "Plus": "Ingredient Magnet S (Plus)",
        "DreamShardMagnetS": "Dream Shard Magnet S",
        "CookingPowerUpS": "Cooking Power-Up S",
        "CookingPowerUpSMinus": "Cooking Power-Up S (Minus)",
        "Minus": "Cooking Power-Up S (Minus)",
        "BulkUp": "Cooking Assist S (Bulk Up)",
        "TastyChanceS": "Tasty Chance S",
        "SkillCopyMimic": "Skill Copy (Mimic)",
        "Mimic": "Skill Copy (Mimic)",
        "SkillCopyTransform": "Skill Copy (Transform)",
        "Transform": "Skill Copy (Transform)",
        "ChargeEnergySMoonlight": "Charge Energy S (Moonlight)",
        "Moonlight": "Charge Energy S (Moonlight)",
        "IngredientDrawS": "Ingredient Draw S",
        "IngredientDrawSHyperCutter": "Ingredient Draw S (Hyper Cutter)",
        "HyperCutter": "Ingredient Draw S (Hyper Cutter)",
        "IngredientDrawSSuperLuck": "Ingredient Draw S (Super Luck)",
        "SuperLuck": "Ingredient Draw S (Super Luck)",
        "ExtraHelpfulS": "Extra Helpful S",
        "PresentIngredient": "Ingredient Magnet S (Present)",
        "PresentIngredientMagnetS": "Ingredient Magnet S (Present)",
        "BerryBurstDisguise": "Berry Burst (Disguise)",
        "EnergizingCheerSNuzzle": "Energizing Cheer S (Nuzzle)",
        "Nuzzle": "Energizing Cheer S (Nuzzle)",
        "HealPulse": "Energizing Cheer S (Heal Pulse)",
        "Versatile": "Versatile (Metronome)"
    };
    if (customNames[name]) return customNames[name];
    // Automatically injects spaces between lowercase and uppercase letters,
    // as well as consecutive capitalizations correctly (e.g., SPlus -> S Plus)
    return name
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
        .trim();
};

export const formatFrequency = (freq) => {
    if (!freq) return "Unknown";
    const h = Math.floor(freq / 3600);
    const m = Math.floor((freq % 3600) / 60);
    const s = freq % 60;
    if (h > 0) return `${h}h ${m}m ${s}s`;
    return `${m}m ${s}s`;
};

export const formatIngredientName = (rawName) => {
    if (!rawName) return "Unknown";
    const parts = rawName.split('_');
    const name = parts[parts.length - 1].toLowerCase();
    return name.charAt(0).toUpperCase() + name.slice(1);
};
